// extracted by mini-css-extract-plugin
module.exports = {"blue1Dark":"#0a407e","fontFamily1":"\"Roboto\",\"Helvetica\",\"Arial\",sans-serif","headerBreakpoint5":"720px","hr":"HR_hr__2iDoD"};